/** @jsxImportSource @emotion/react */
import * as React from 'react';
 import { css} from '@emotion/react'
 import { Form, Input, Radio, Space, Table} from 'antd';
import { Pagination } from 'antd';
import Button from '@mui/material/Button';
import { useState } from 'react';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { ButtonBase, IconButton } from '@mui/material';
import config from '../../config';
import axios from '../apiClient';
import { useEffect } from 'react';
import { useRef } from 'react';
import Loader from '../loader';
import Alert from '../alert';
import moment from 'moment';
import { useLang } from '../../context';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'white',
  borderRadius: "1rem",
  boxShadow: 24,
  p: 4,
};

export default function WithdrawRequests() {
  const [page,setPage] = useState(1);
  const [requests,setRequests] = useState([]);
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [totalRequests, setTotalRequests] = useState();
  const [openModel, setOpenModel] = React.useState(false);
  const [radioValue, setRadioValue] = React.useState("add");
  const [modalLoading,setModalLoading] = useState(false)
  const [selectedMemberId,setSelectedMemberId] = useState()
  const [selectedAmount,setSelectedAmount] = useState()
  const mounted = useRef(false)
  const {text} = useLang();

  // get data from backend when componenet is first mounted
  async function fetchData() {
    setLoading(true)
    let data = await axios.get(`/wallet/getWithdrawRequest?current=${page}&pageSize=10`)

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setRequests([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    };
    
    setRequests(data.data.withdraw_request)
    setTotalRequests(data.data.pagination.total)
    setLoading(false)
}
  //--------------------------------------------------
  useEffect(()=>{
    localStorage.setItem("notiCount",0);
    // console.log("document",document.getElementById("noti"));
    if(document.getElementById('noti')){
      document.getElementById('noti').innerHTML = '0';
    }
    if(mounted){
      fetchData()
    }
  },[page])

  useEffect(()=>{
    mounted.current = true
    fetchData()
  },[])

  const handleModelClose = () => setOpenModel(false);
  const onFinish = async (values) => {
    const {otp} = values
    setModalLoading(true)
    // const reason = action == 'add' ? 'Deposit' :  'Withdraw';
    let params = {  
        "requestId": selectedMemberId, 
        "otp": otp,
        // "successTrnx": "923892389294"
    };

    let data = await axios.post(`/wallet/receiveWithdrawRequest`, params)
    setErrorMsg({ code: data.code, msg: data.message })
    setOpenAlert(true)
    setModalLoading(false)
    if(data.code == 200){
      setOpenModel(false)
      fetchData()
    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  const columns = [
    {
      title: text['Username'],
      dataIndex: 'memberInfo',
      render: (memberInfo) => memberInfo.username, 
      key: 'username',
    },
    {
      title: text['Full Name'],
      dataIndex: 'memberInfo',
      render: (memberInfo) => memberInfo.full_name, 
      key: 'full_name',
    },
    {
      title: text['Amount'],
      key: 'amount',
      dataIndex: 'amount',
      align: 'right',
      render: (amount) => Number(amount).toLocaleString(),
    },
    {
      title: text['Payment Method'],
      key: 'payment_mayment',
      dataIndex: 'payment_method',
    },
    {
        title: text['Card Number'],
        key: 'card_number',
        dataIndex: 'card_number',
    },
    {
        title: text['Status'],
        key: 'status',
        dataIndex: 'status',
    },
    {
      title: text['Requested Date'],
      key: 'requested_at',
      dataIndex: 'requested_at',
      render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
    },
    {
      title: text['Action'],
      render: (obj) => {
        const managePointsColor = "#0E8388";
        const {request_id,status,amount} = obj ;
        const disabledBtn = status == 'success' ? true : false;
        const disabledColor = status == 'success' ? 'graylight' : managePointsColor;
  
        return (
        <Space size="middle">
          <Button disabled={disabledBtn} onClick={()=> {
            setOpenModel(true);
            setSelectedMemberId(request_id)
            setSelectedAmount(amount)
          }} css={css`color: black;border-color: ${managePointsColor};:hover{border-color: ${managePointsColor};}`} color='success' variant="outlined" startIcon={<MonetizationOnRoundedIcon css={css`color: ${disabledColor};`}/> }>
            {text['Receive']}
         </Button>
        </Space>
      )},
    },
  ];
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }

  const handlePageChange = (page) => {
    setPage(page)
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModel}
        onClose={handleModelClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModel}>
          <Box sx={style} css={css`padding: 1.4rem 32px;`}>      
            <div css={css`display: flex;justify-content: center;align-items: center;margin-top: 0.4rem;font-size: 2rem;font-weight: bold;`}>
              {text['Amount']}: {selectedAmount != null ? Number(selectedAmount).toLocaleString() : ''}
            </div>
            <Form
              name="basic"
              className="modal-points"
              style={{
                marginTop: "2rem",
                fontFamily: "inherit",
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label={text["Enter OTP"]}
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="otp"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please input OTP!`,
                  },
                ]}
              >
                <Input 
                onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
                type="number"  size="large" css={css`margin-left: 2rem;`} min={0}/>
              </Form.Item>

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  padding: "0.6rem 0 0 0",
                  marginTop: "1rem",
                }}
              >
                <ButtonBase
                  component="button"
                  onClick={()=> setOpenModel(false)}
                  style={{
                    color: "black",
                    display: "flex",
                    backgroundColor: "#D27685",
                    padding: "0.6rem 1.8rem",
                    borderRadius: "2rem",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "1rem"
                  }}
                >
                  <h4 style={{ textAlign: "center", margin: 0 }}>{text['Cancel']}</h4>
                </ButtonBase>
                <ButtonBase
                  type="submit"
                  component="button"
                  style={{
                    color: "black",
                    display: "flex",
                    backgroundColor: "#408E91",
                    padding: "0.6rem 1.8rem",
                    borderRadius: "2rem",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {modalLoading? <Loader btn creatUser/> : <h4 style={{ textAlign: "center", margin: 0 }}>{text['Receive']}</h4>}
                </ButtonBase>
              
              </div>
            </Form>
          </Box>
        </Fade>
      </Modal>
    <div>
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
    
      <Table loading={loading} scroll={{x: 'max-content'}} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={requests} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalRequests} pageSize={10} showSizeChanger={false} onChange={(page)=> handlePageChange(page)}/>
    </div>
  </div>
  )
}
